{
  "version": 1,
  "asset_id": "19ca660e-82cd-4b2b-8faf-ebab7ed5a465",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/19ca660e-82cd-4b2b-8faf-ebab7ed5a465/clip-img_0120.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/19ca660e-82cd-4b2b-8faf-ebab7ed5a465/clip-img_0120.mp4",
  "original_filename": "clip-img_0120.mp4",
  "size": 725979,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T18:33:41Z"
}
